import { useLoyaltyStore } from "stores/loyalty";
import { useGetUserProgressLoyalty } from "../../queries/useGetUserProgressLoyalty";
import { LoyaltyMoreRewards } from "../../components/organisms/LoyaltyMoreRewards";
import { useGetProgressLoyalty } from "../../queries/useGetProgressLoyalty";
import { LoyaltyRewardsBFF } from "../../types/LoyaltyBFF";

export const LoyaltyMoreRewardsContainer = () => {
  const { data } = useGetUserProgressLoyalty();
  const indexActiveRank = useLoyaltyStore((state) => state.indexActiveRank);
  const { data: progressData } = useGetProgressLoyalty();
  const experience = progressData?.data?.data?.experience || 0;
  const firstRankRequirement = data?.ranks?.[0]?.levels?.[0]?.requirement ?? 0;
  let rewardsNextRank: LoyaltyRewardsBFF | null = null;

  if (experience < firstRankRequirement) {
    rewardsNextRank = data?.ranks?.[0]?.rewards || null;
  } else {
    const nextRank = data?.ranks?.[indexActiveRank + 1];
    rewardsNextRank = nextRank?.rewards || null;
  }

  return <LoyaltyMoreRewards rewardsNextRank={rewardsNextRank} />;
};
